/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _helpersConnectData = require('helpers/connectData');

var _helpersConnectData2 = _interopRequireDefault(_helpersConnectData);

var _reactRedux = require('react-redux');

var _reduxModulesSpecialSeries = require('redux/modules/specialSeries');

var _reduxModulesSpecialSeriesCategory = require('redux/modules/specialSeriesCategory');

var _reduxModulesAdGroup = require('redux/modules/adGroup');

var _components = require('components');

var _lodashFilter = require('lodash/filter');

var _lodashFilter2 = _interopRequireDefault(_lodashFilter);

var _lodashFind = require('lodash/find');

var _lodashFind2 = _interopRequireDefault(_lodashFind);

var _lodashIsEmpty = require('lodash/isEmpty');

var _lodashIsEmpty2 = _interopRequireDefault(_lodashIsEmpty);

var _lodashMap = require('lodash/map');

var _lodashMap2 = _interopRequireDefault(_lodashMap);

var _lodashSortBy = require('lodash/sortBy');

var _lodashSortBy2 = _interopRequireDefault(_lodashSortBy);

function fetchDataDeferred(getState, dispatch) {
	var state = getState();

	var promises = [];

	if (!_reduxModulesAdGroup.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesAdGroup.load(119078)));
	}

	if (!_reduxModulesSpecialSeries.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesSpecialSeries.load()));
	}

	if (!_reduxModulesSpecialSeriesCategory.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesSpecialSeriesCategory.load(state.router.params.name, -1)));
	}

	return _Promise.all(promises);
}

var SpecialSeries = (function (_Component) {
	_inherits(SpecialSeries, _Component);

	function SpecialSeries() {
		_classCallCheck(this, _SpecialSeries);

		_Component.apply(this, arguments);
	}

	SpecialSeries.prototype.render = function render() {
		var _this = this;

		var styles = require('./SpecialSeriesCategory.css');
		var articles = this.props.articles.results;
		var image = this.props.articles.image;

		var _props = this.props;
		var ads = _props.ads;
		var isSmallViewport = _props.isSmallViewport;
		var isMediumViewport = _props.isMediumViewport;
		var loading = _props.loading;
		var series = _props.series;
		var seriesLoading = _props.seriesLoading;

		// Show loading spinner while article is fetched
		if (loading || loading === undefined) {
			return _react2['default'].createElement(
				'main',
				{ className: styles.Base },
				_react2['default'].createElement(_reactLoader2['default'], {
					className: 'spinner',
					color: 'rgb(255, 78, 61)',
					corners: 0,
					direction: 1,
					hwaccel: true,
					left: '50%',
					length: 6,
					lines: 13,
					opacity: 0.1,
					radius: 7,
					rotate: 13,
					scale: 1.00,
					shadow: false,
					speed: 2,
					top: '50%',
					trail: 60,
					width: 2,
					zIndex: 2e9 })
			);
		}

		var adsBottom = _lodashFind2['default'](ads, function (ad) {
			return ad.position === 'bottom';
		});
		var adsBottomSquare = undefined;
		var adsBottomLeaderboard = undefined;
		if (!_lodashIsEmpty2['default'](adsBottom)) {
			// Get all 300×250 ads
			adsBottomSquare = _lodashFilter2['default'](adsBottom.ads, function (ad) {
				return ad.title.indexOf('300x250') > -1;
			});
			// Get all 728x90 ads
			adsBottomLeaderboard = _lodashFilter2['default'](adsBottom.ads, function (ad) {
				return ad.title.indexOf('728x90') > -1;
			});
		}

		var seriesTitle = this.props.articles.details.name;
		var description = this.props.articles.details.description || 'The ' + seriesTitle + ' series needs a description added!';

		var latestSpecialSeries = series.results;
		latestSpecialSeries = _lodashSortBy2['default'](latestSpecialSeries, function (article) {
			return article.latestPost.post_date;
		}).reverse();

		var articleCount = articles.length;

		var categoryArticles = _lodashMap2['default'](articles, function (article, index) {
			var _classNames;

			var headerClasses = _classnames2['default']((_classNames = {}, _classNames[styles.ArticleHeader] = article.images['bbrew-small'], _classNames[styles['ArticleHeader--noImage']] = !article.images['bbrew-small'], _classNames));

			return _react2['default'].createElement(
				'div',
				{ className: styles.ArticleWrapper, key: article.id },
				adsBottomLeaderboard && adsBottomLeaderboard.length > 0 && index === Math.round(articleCount / 2) && !isSmallViewport && !isMediumViewport && _react2['default'].createElement(
					'section',
					{ className: styles.AdSpace },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsBottomLeaderboard[0].url,
							ratio: '8x1',
							target: '_blank'
						},
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsBottomLeaderboard[0].image.src, alt: adsBottomLeaderboard[0].image.title })
					)
				),
				adsBottomSquare && adsBottomSquare.length > 0 && index === Math.round(articleCount / 2) && (isSmallViewport || isMediumViewport) && _react2['default'].createElement(
					'section',
					{ className: styles.AdSpace },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsBottomSquare[0].url,
							ratio: '4x3',
							target: '_blank'
						},
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsBottomSquare[0].image.src, alt: adsBottomSquare[0].image.title })
					)
				),
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.ArticleLink, to: article.url },
					_react2['default'].createElement(
						'article',
						{ className: styles.Article },
						!isSmallViewport && article.images['bbrew-small'] ? _react2['default'].createElement(
							'figure',
							{ className: styles.ArticleFigure },
							_react2['default'].createElement('img', { src: '' + _srcSettings2['default'].cdn + article.images['bbrew-small'][0] })
						) : null,
						_react2['default'].createElement(
							'header',
							{ className: headerClasses },
							_react2['default'].createElement(_components.MetaBar, {
								articleID: article.id,
								author: article.author.guest ? article.author.guest[0] : article.author.name,
								commentCount: article.commentCount,
								noLinks: true,
								postDate: article.date }),
							_react2['default'].createElement(
								'h1',
								{ className: styles.ArticleTitle },
								article.title
							),
							isSmallViewport ? _react2['default'].createElement(
								'figure',
								{ className: styles.ArticleFigure },
								_react2['default'].createElement('img', { src: '' + _srcSettings2['default'].cdn + article.images['bbrew-small'][0] })
							) : null,
							_react2['default'].createElement('div', { className: styles.ArticleSnippet, dangerouslySetInnerHTML: { __html: article.excerpt } })
						)
					)
				)
			);
		});

		// Terrible fix for DISQUS comment count issue
		var waitForLoadToComplete = setInterval(function () {
			if (!_this.props.loading) {
				clearInterval(waitForLoadToComplete);
				(function () {
					window.DISQUSWIDGETS = undefined;
					var s = document.createElement('script');
					s.id = 'dsq-count-scr';
					s.async = true;
					s.type = 'text/javascript';
					s.src = 'https://baltimorebrew.disqus.com/count.js';
					(document.getElementsByTagName('HEAD')[0] || document.getElementsByTagName('BODY')[0]).appendChild(s);
				})();
			}
		}, 500);

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: 'Special Series | ' + seriesTitle }),
			_react2['default'].createElement(
				'section',
				{ className: styles.SpecialSeries },
				_react2['default'].createElement(
					'figure',
					{ className: styles['Figure--featured'] },
					_react2['default'].createElement('img', { className: styles.FigureImage, src: '' + _srcSettings2['default'].cdn + (image ? image : articles[0].images['bbrew-feature-small'][0]) })
				),
				_react2['default'].createElement(
					'header',
					{ className: styles.SectionHeader },
					_react2['default'].createElement(
						'h1',
						{ className: styles.Title },
						seriesTitle
					),
					_react2['default'].createElement(
						'p',
						{ className: styles.Intro },
						description
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Articles },
					categoryArticles
				),
				_react2['default'].createElement(
					'footer',
					{ className: styles.SectionFooter },
					_react2['default'].createElement(
						_reactRouter.Link,
						{ to: '/special-series', className: styles.SeeMore },
						'More Special Series'
					),
					!seriesLoading && _react2['default'].createElement(
						'ul',
						{ className: styles.TiledLinks },
						latestSpecialSeries.map(function (link, index) {
							if (index < 5) return _react2['default'].createElement(
								'li',
								{ key: index, className: styles.TiledLink },
								_react2['default'].createElement(
									_reactRouter.Link,
									{ to: '/special-series/' + link.slug },
									link.name
								)
							);
							return false;
						}),
						_react2['default'].createElement(
							'li',
							{ className: styles.TiledLink },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ to: '/special-series/' },
								_react2['default'].createElement(
									'em',
									null,
									'See All'
								)
							)
						)
					)
				)
			)
		);
	};

	_createClass(SpecialSeries, null, [{
		key: 'propTypes',
		value: {
			ads: _react.PropTypes.array,
			articles: _react.PropTypes.oneOfType([_react2['default'].PropTypes.array, _react2['default'].PropTypes.object]),
			isSmallViewport: _react.PropTypes.bool,
			isMediumViewport: _react.PropTypes.bool,
			loading: _react.PropTypes.bool,
			location: _react.PropTypes.object,
			series: _react.PropTypes.oneOfType([_react2['default'].PropTypes.array, _react2['default'].PropTypes.object]),
			seriesLoading: _react.PropTypes.bool
		},
		enumerable: true
	}]);

	var _SpecialSeries = SpecialSeries;
	SpecialSeries = _reactRedux.connect(function (state) {
		return {
			ads: state.adGroup.data,
			articles: state.specialSeriesCategory.data,
			isSmallViewport: state.responsive.isSmallViewport,
			isMediumViewport: state.responsive.isMediumViewport,
			loading: state.specialSeriesCategory.loading,
			series: state.specialSeries.data,
			seriesLoading: state.specialSeries.loading
		};
	})(SpecialSeries) || SpecialSeries;
	SpecialSeries = _helpersConnectData2['default'](null, fetchDataDeferred)(SpecialSeries) || SpecialSeries;
	return SpecialSeries;
})(_react.Component);

exports['default'] = SpecialSeries;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/SpecialSeriesCategory/SpecialSeriesCategory.js
 ** module id = 711
 ** module chunks = 0
 **/